import { render, staticRenderFns } from "./InitiateReversal.vue?vue&type=template&id=31a22259&scoped=true&"
import script from "./InitiateReversal.vue?vue&type=script&lang=js&"
export * from "./InitiateReversal.vue?vue&type=script&lang=js&"
import style0 from "./InitiateReversal.vue?vue&type=style&index=0&lang=css&"
import style1 from "./InitiateReversal.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./InitiateReversal.vue?vue&type=style&index=2&id=31a22259&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../front.sfc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a22259",
  null
  
)

export default component.exports